export const tagEmHtml = (nomeDaTag) => {
  const formatarNomeDaTag = nomeDaTag.toUpperCase();
  const tagHtml = `<span>${formatarNomeDaTag}</span>`;
  return tagHtml;
}
